var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "shortcuts-container" }, [
    _c("div", { staticClass: "shortcuts-section" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("CTRL")]),
            _vm._v("\n                +\n                "),
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("M")]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.openPrivateChat")) +
              "\n            "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [_c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("ESC")])],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.escKey")) +
              "\n            "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("CTRL")]),
            _vm._v("\n                +\n                "),
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("K")]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("search.searchAreaTitle")) +
              "\n            "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [_c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("F1")])],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.focusInput")) +
              "\n            "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [_c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("F4")])],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.previousOpenedChat")) +
              "\n            "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [_c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("TAB")])],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.showSystemStatus")) +
              "\n            "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("CTRL")]),
            _vm._v("\n                +\n                "),
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v(",")]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.copilot_desc_num")) +
              "\n            "
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "shortcuts-section" }, [
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [
            _c("b-badge", { attrs: { variant: "primary" } }, [
              _vm._v("Command"),
            ]),
            _vm._v("\n                +\n                "),
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("M")]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.openPrivateChat")) +
              "\n            "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [_c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("ESC")])],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.escKey")) +
              "\n            "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [
            _c("b-badge", { attrs: { variant: "primary" } }, [
              _vm._v("Command"),
            ]),
            _vm._v("\n                +\n                "),
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("K")]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("search.searchAreaTitle")) +
              "\n            "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [_c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("F1")])],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.focusInput")) +
              "\n            "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [_c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("F4")])],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.previousOpenedChat")) +
              "\n            "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [_c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("TAB")])],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.showSystemStatus")) +
              "\n            "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [
            _c("b-badge", { attrs: { variant: "primary" } }, [
              _vm._v("Command"),
            ]),
            _vm._v("\n                +\n                "),
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v(",")]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.copilot_desc_num")) +
              "\n            "
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "shortcuts-section" }, [
      _c("div", { staticClass: "section-header" }, [
        _c("div", { staticClass: "os-header" }, [
          _c("i", { staticClass: "far fa-comment-dots" }),
          _vm._v(" "),
          _c("h3", [_vm._v(_vm._s(_vm.$t("message.chatShortcuts")))]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "divider" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [
            _c(
              "b-badge",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: {
                      content: _vm.$t("message.examplePm"),
                      placement: "top",
                      theme: "light-border",
                    },
                    expression:
                      "{\n                        content: $t('message.examplePm'),\n                        placement: 'top',\n                        theme: 'light-border'\n                    }",
                  },
                ],
                attrs: { variant: "success" },
              },
              [_vm._v("pm:")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.pmDescription")) +
              "\n            "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [
            _c(
              "b-badge",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: {
                      content: _vm.$t("message.exampleName"),
                      placement: "top",
                      theme: "light-border",
                    },
                    expression:
                      "{\n                        content: $t('message.exampleName'),\n                        placement: 'top',\n                        theme: 'light-border'\n                    }",
                  },
                ],
                attrs: { variant: "success" },
              },
              [_vm._v("@name")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.nameDescription")) +
              "\n            "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [
            _c(
              "b-badge",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: {
                      content: _vm.$t("message.exampleEmail"),
                      placement: "top",
                      theme: "light-border",
                    },
                    expression:
                      "{\n                        content: $t('message.exampleEmail'),\n                        placement: 'top',\n                        theme: 'light-border'\n                    }",
                  },
                ],
                attrs: { variant: "success" },
              },
              [_vm._v("@email")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.descriptionEmail")) +
              "\n            "
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "shortcuts-section" }, [
      _vm._m(2),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("Ctrl")]),
            _vm._v("\n                +\n                "),
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("W")]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v("\n                Görüşmeyi Sonlandır\n            "),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("Ctrl")]),
            _vm._v("\n                +\n                "),
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("F")]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v("\n                Görüşmeyi Yönlendir\n            "),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("Ctrl")]),
            _vm._v("\n                +\n                "),
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("P")]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v("\n                Gizli Mesaj Gönder\n            "),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("Ctrl")]),
            _vm._v("\n                +\n                "),
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("B")]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v("\n                Kişiyi Engelle\n            "),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("Ctrl")]),
            _vm._v("\n                +\n                "),
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("T")]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v("\n                Görev Oluştur\n            "),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("Ctrl")]),
            _vm._v("\n                +\n                "),
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("O")]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v("\n                Profili Göster\n            "),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [_c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("C")])],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v("\n                Cevaplandı Olarak İşaretle\n            "),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("Ctrl")]),
            _vm._v("\n                +\n                "),
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("1")]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v("\n                Chat Layout'a Geç\n            "),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("Ctrl")]),
            _vm._v("\n                +\n                "),
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("2")]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v("\n                Table Layout'a Geç\n            "),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("Ctrl")]),
            _vm._v("\n                +\n                "),
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("3")]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v("\n                Kanban Layout'a Geç\n            "),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-header" }, [
      _c("div", { staticClass: "os-header" }, [
        _c("i", { staticClass: "fa-brands fa-windows" }),
        _vm._v(" "),
        _c("h3", [_vm._v("Windows")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "divider" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-header" }, [
      _c("div", { staticClass: "os-header" }, [
        _c("i", { staticClass: "fa-brands fa-apple" }),
        _vm._v(" "),
        _c("h3", [_vm._v("macOS")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "divider" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-header" }, [
      _c("div", { staticClass: "os-header" }, [
        _c("i", { staticClass: "far fa-window-maximize" }),
        _vm._v(" "),
        _c("h3", [_vm._v("Chat Penceresi")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "divider" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }